import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "data-confirm-modal": "",
  class: "space-y-2 text-sm leading-relaxed text-gray-600"
}

import HighlightedText from '@/components/neue/wizard/HighlightedText'
import WizardButton from '@/components/neue/wizard/WizardButton.vue'
import TheModal from '@/components/TheModal.vue'


export default {
  __name: 'WizardConfirmModal',
  props: {
  open: { type: Boolean, default: false },
  title: { type: String, required: true },
  lines: { type: Array, default: () => [] },
  confirmLabel: { type: String, default: 'Confirm' },
  cancelLabel: { type: String, default: 'Cancel' },
  danger: { type: Boolean, default: false }
},
  emits: ['confirm', 'cancel'],
  setup(__props) {




return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(TheModal, {
    "is-open": __props.open,
    "modal-title": __props.title,
    "max-width": "max-w-md",
    onCloseModal: _cache[2] || (_cache[2] = $event => (_ctx.$emit('cancel')))
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lines, (line) => {
          return (_openBlock(), _createElementBlock("p", {
            key: line,
            class: "m-0"
          }, [
            _createVNode(_unref(HighlightedText), { text: line }, null, 8, ["text"])
          ]))
        }), 128))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(WizardButton, {
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.cancelLabel), 1)
        ]),
        _: 1
      }),
      _createVNode(WizardButton, {
        variant: __props.danger ? 'danger' : 'primary',
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('confirm')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.confirmLabel), 1)
        ]),
        _: 1
      }, 8, ["variant"])
    ]),
    _: 1
  }, 8, ["is-open", "modal-title"]))
}
}

}